import { render, staticRenderFns } from "./LiveManagementList.vue?vue&type=template&id=5109bc26"
import script from "./LiveManagementList.vue?vue&type=script&lang=js"
export * from "./LiveManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports